import {Component, computed, ChangeDetectionStrategy} from "@angular/core"
import {ValueSlotComponent, SelectionPossibilities} from "@app/template-editor/components/value-slot/value-slot.component"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {GeometryAttributeValueLike, GeometryReduceOperator, ReduceOperatorOption, reduceOperatorOptions} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-geometry-attribute-value-like-node-inspector",
    templateUrl: "./geometry-attribute-value-like-node-inspector.component.html",
    styleUrls: ["./geometry-attribute-value-like-node-inspector.component.scss"],
    imports: [InspectorSectionComponent, ValueSlotComponent],
    standalone: true,
})
export class GeometryAttributeValueLikeNodeInspectorComponent extends BaseInspectorComponent<GeometryAttributeValueLike> {
    readonly $reduceOperatorLike = computed(() => {
        const node = this.$node()
        return node instanceof GeometryReduceOperator ? node : null
    })

    reduceOperatorSelectionPossibilities: SelectionPossibilities<ReduceOperatorOption> = reduceOperatorOptions.map((option) => ({
        name: option,
        value: option,
    }))
}
